import { ProfileRoutes, ProfileStore } from "./modules/profile";

export default {
  install(Vue, options) {
    /* register store and routes */
    if (options.router) options.router.addRoute(...ProfileRoutes);
    if (options.store) options.store.registerModule("profile", ProfileStore);
  },
};
